export const SAMPLE_PRODUCTS_BASE = '/sample-products';

export function sampleProductsPath(path = '') {
  if (!path || path === '/') return SAMPLE_PRODUCTS_BASE;
  return `${SAMPLE_PRODUCTS_BASE}${path.startsWith('/') ? path : `/${path}`}`;
}
